import { useState, type FormEvent } from "react";

import { ErroAPI } from "../api.ts";
import { useSessao } from "../sessao.tsx";

export function Login() {
  const { entrar } = useSessao();
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setErro("");
    setEnviando(true);
    try {
      await entrar(login, senha);
    } catch (err) {
      // Mensagem generica, venha do servidor ou nao: dizer "usuario nao existe"
      // entregaria quem tem conta no painel.
      setErro(err instanceof ErroAPI ? err.message : "Nao consegui entrar agora.");
      setEnviando(false);
    }
  }

  return (
    <div className="login">
      <form className="login__caixa" onSubmit={enviar}>
        <img src="/logo-conceitto.webp" alt="Conceitto" className="login__logo" />
        <p className="login__titulo">Gestao de licencas</p>

        {erro && <div className="alerta alerta--erro">{erro}</div>}

        <label className="campo">
          <span className="campo__rotulo">Login</span>
          <input type="text" value={login} autoComplete="username" autoFocus required
                 onChange={(e) => setLogin(e.target.value)} />
        </label>
        <label className="campo">
          <span className="campo__rotulo">Senha</span>
          <input type="password" value={senha} autoComplete="current-password" required
                 onChange={(e) => setSenha(e.target.value)} />
        </label>
        <button className="botao" type="submit" disabled={enviando}>
          {enviando ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
